<img [style.width]="width"  [style.height]="height" [ngStyle.lt-md]="{'height':heightMob, 'width':'100%'}"
    (click)="navigation==0?goToCategories(catId):link(navigatedUrl)"
    [src]="image" [alt]="altImage || 'images'" loading="lazy">